export var ContractStatus;
(function (ContractStatus) {
    ContractStatus["CREATED"] = "CREATED";
    ContractStatus["SYNC_CONTRACT_DATA"] = "SYNC_CONTRACT_DATA";
    ContractStatus["PENDING"] = "PENDING";
    ContractStatus["SYNC_BENEFICIARIES_PARTNER"] = "SYNC_BENEFICIARIES_PARTNER";
    ContractStatus["ACTIVE"] = "ACTIVE";
    ContractStatus["REJECTED"] = "REJECTED";
    ContractStatus["EXPIRED"] = "EXPIRED";
    ContractStatus["CANCELED"] = "CANCELED";
})(ContractStatus || (ContractStatus = {}));
export var BenefitPartner;
(function (BenefitPartner) {
    BenefitPartner["VR"] = "VR";
})(BenefitPartner || (BenefitPartner = {}));
